<template>
    <div>
        <el-dialog append-to-body :title="'请选择需要删除的实例('+ delNum+ '个)'"
            :visible="visible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            @close="cancel"
            width="80%">
            <h4>
                设备名称：{{params.deviceName}}
            </h4>
            <el-form :model="form" ref="form" label-width="200px" label-position="left">
                <el-form-item v-for="(ins, index) in form.insList" :key="index"
                    :prop="'insList.'+index+ '.instanceIds'"
                    :rules="ins.instanceList.length > 0 ? numRule : []"
                    :label="ins.moduleType">
                    <el-select multiple
                        :multiple-limit="delNum"
                        v-model="ins.instanceIds" style="width:80%;">
                        <el-option v-for="(item, idx) in ins.instanceList" :key="idx"
                            :label="'实例'+item.id"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-row class="self_row" style="text-align: right;">
                <el-button @click="cancel" size="mini">取消</el-button>
                <el-button type="primary" @click="save" size="mini">确定</el-button>
            </el-row>
        </el-dialog>
    </div>
</template>
<script>
import { Loading } from "element-ui";
export default {
    props: {
        // 请求列表需要的参数
        params: {
            type: Object
        },
        visible: {
            type: Boolean
        }
    },
    data(){
        let numValid = (rule, value, callback) => {
            if(!value){
                callback(new Error('请选择需要删除的实例'))
                return
            }
            if(value && value.length < this.delNum){
                callback(new Error('需要删除'+ this.delNum + '个实例哦'))
            }else{
                callback()
            }
        }
        return {
            form: {
                insList: [],
                // insObj: {},
            },
            numRule: [
                {validator: numValid, trigger: 'change'},
                {required: true, message: '必填项'}
            ],
        }
    },
    computed: {
        delNum(){
            return this.params.oldNum - this.params.newNum
        }
    },
    created(){
        this.getList()
    },
    methods: {
        // 获取实例列表
        getList(){
            let loading = Loading.service({
                fullscreen: true,
                text: "数据加载中..."
            });
            this.$axios
            .get(this.baseUrl3 + 'instance2/findAllIns/onDevice/'
                 + this.params.arrangeId + '/'
                 + this.params.group + '/'
                 + this.params.moduleType + '/'
                 + this.params.moduleVersion + '/'
                 + this.params.deviceId )
            .then(({data: {code, data, msg}})=>{
                if(code == 20000){
                    this.form.insList = []
                    let model = {}
                    for(let key in data){
                        model = {
                            moduleType: key,
                            instanceList: data[key],
                            instanceIds: []
                        }
                        this.form.insList.push(model)
                    }
                }else{
                    this.$message.error(msg)
                }
                loading.close()
            })
            .catch( err => {
                console.log(err)
                loading.close()
            })
        },
        // 批量删除实例
        // del(){
        //     let ids = []
        //     this.form.insList.forEach(ins => {
        //         ids = ids.concat(ins.instanceIds)
        //     })
        //     if(ids.length == 0){
        //         return
        //     }
        //     let loading = Loading.service({
        //         fullscreen: true,
        //         text: "数据加载中..."
        //     });
        //     this.$axios
        //     .post(this.baseUrl + 'instance2/batch/del',
        //           ids)
        //     .then(({data: {code, data, msg}})=>{
        //         if(code == 20000){
        //             this.$emit('dialogClose')
        //         }else{
        //             this.$message.error(msg)
        //         }
        //         loading.close()
        //     })
        //     .catch( err => {
        //         console.log(err)
        //         loading.close()
        //     })
        // },
        save(){
            this.$refs.form.validate(valid => {
                if(valid){
                    // this.del()
                    let ids = []
                    this.form.insList.forEach(ins => {
                        ids = ids.concat(ins.instanceIds)
                    })
                    this.$emit('dialogClose', ids)
                }
            })

        },
        cancel(){
            this.$emit('dialogClose', false)
        },
    }
}
</script>
<style scoped>
.self_row{
    margin: 15px 0;
}
</style>
